var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 65,
    viewBox: "0 0 86 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9374 0H8.06256C3.61659 0 0 3.61659 0 8.06256V56.4375C0 60.8835 3.61659 64.5001 8.06256 64.5001H77.9374C82.3834 64.5001 86 60.8835 86 56.4375V8.06256C86 3.61659 82.3834 0 77.9374 0V0ZM77.9374 5.37498C78.3026 5.37498 78.65 5.45074 78.9675 5.58304L43 36.7563L7.0323 5.58304C7.34987 5.45092 7.69723 5.37498 8.06238 5.37498H77.9374ZM77.9374 59.1249H8.06256C6.57973 59.1249 5.37498 57.9204 5.37498 56.4374V11.2618L41.2389 42.3439C41.7455 42.7821 42.3728 43 43 43C43.6272 43 44.2545 42.7823 44.7611 42.3439L80.625 11.2618V56.4375C80.6248 57.9204 79.4203 59.1249 77.9374 59.1249V59.1249Z",
    fill: "#42BF76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContact);
export default __webpack_public_path__ + "static/media/email-contact.83eda8ca0a2c07fad69b15442a6d7897.svg";
export { ForwardRef as ReactComponent };